import { ColDef } from 'ag-grid-enterprise';

export const ART_PIECE_COLUMN_HEADERS_CONFIG : any = {
  columnDefs: getArtPieceColumnDefs()
};

function getArtPieceColumnDefs(): ColDef[] {

  const commonDefaults: Partial<ColDef> = {
    sortable: true,
    resizable: true,
    editable: false,
    hide: false,
    rowGroup: false,
    checkboxSelection: false,
    rowDrag: false,
    filter: 'agTextColumnFilter',
    cellStyle: { textAlign: 'center' }
  };

  const addColumn = (
    field: string,
    headerName: string,
    width = 150,
    overrides: Partial<ColDef> = {}
  ): ColDef => ({
    colId: field, 
    field,
    headerName,     
    width: Number(width), 
    ...commonDefaults,
    ...overrides
  });

  return [
    addColumn('pic', 'Picture', 150, {
      filter: false,
      floatingFilter: false,
      cellRenderer: 'imageEditor'
    }),

    addColumn('description', 'Description', 250),
    addColumn('licensor', 'Licensor', 250),
    addColumn('property', 'Property', 250),
    addColumn('little_theme', 'Little Theme', 250),
    addColumn('big_theme', 'Big Theme', 250),
    addColumn('art_type', 'Art Type', 250),
    addColumn('art_source', 'Art Source', 250),
    addColumn('artist', 'Artist', 250),
    addColumn('season', 'Season', 250),
    addColumn('age_group', 'Age Group', 250)
  ];
}
